import { render } from "./RelatorioEstacao.vue?vue&type=template&id=885130fc&scoped=true"
import script from "./RelatorioEstacao.vue?vue&type=script&lang=js"
export * from "./RelatorioEstacao.vue?vue&type=script&lang=js"

import "./RelatorioEstacao.vue?vue&type=style&index=0&id=885130fc&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-885130fc"]])

export default __exports__